import { format, fromUnixTime } from 'date-fns';
import React, { useMemo } from 'react';
import Box from '../../../../components/Box';
import Place from '../../../../components/Place';
import StatusCircle from '../../../../components/StatusCircle';
import Typography from '../../../../components/Typography';
import { getLabelHoursJob, getLabelDateStartJob } from '../../../../utils/helpers';
import { makeStyles } from '../../../../utils/styles';

const useStyles = makeStyles((css) => ({
    subTypography: css`
        ${({ theme }) => theme.fonts.mulishRegular};
        font-size: 11px;
        color: ${({ theme }) => theme.colors.dimGrey};
    `,
    boxWrapper: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    `,
    boxFlex: css`
        display: flex;
    `,
    boxTimeStart: css`
        margin-left: 10px;
    `,
    status: css`
        margin-top: 6px;
    `
}));

const JobShortDesc = ({ job, showPlaceLogo, customStyle }) => {
    const styles = useStyles();
    const timeStart = useMemo(() => job?.time_start && fromUnixTime(job.time_start), [job]);
    const timeEnd = useMemo(() => job?.time_end && fromUnixTime(job.time_end), [job]);

    return (
        <Box customStyle={[...styles.boxWrapper, customStyle]}>
            <Box
                customStyle={styles.boxFlex}
            >
                {
                    showPlaceLogo ?
                        <Place
                            logo={job?.place_id?.logo}
                        /> :
                        <StatusCircle size="small" value={job?.status} customStyle={styles.status} />
                }
                <Box customStyle={styles.boxTimeStart}>
                    <Typography>
                        {format(timeStart, 'dd.MM.yyyy')}
                    </Typography>
                    <Typography customStyle={styles.subTypography}>
                        {getLabelDateStartJob(timeStart)}
                    </Typography>
                </Box>
            </Box>
            {
                job?.title &&
                <Box>
                    <Typography>
                        {job?.title}
                    </Typography>
                </Box>
            }
            {
                job?.profession_id?.name &&
                <Box>
                    <Typography>
                        {job?.profession_id?.name}
                    </Typography>
                </Box>
            }
            {
                (timeStart && timeEnd) &&
                <Box>
                    <Typography>
                        {`${format(timeStart, 'HH:mm')} - ${format(timeEnd, 'HH:mm')}`}
                    </Typography>
                    <Typography customStyle={styles.subTypography}>
                        {getLabelHoursJob(timeEnd, timeStart)}
                    </Typography>
                </Box>
            }
        </Box>
    );
};

JobShortDesc.defaultProps = {
    customStyle: []
};

export default JobShortDesc;
